/**
 * @module Helpers
 */
const {
  callGtagConfig,
  callGtagEvent,
  callSegmentIdentify,
  callSegmentPage,
  callSegmentTrack,
} = require('./analytics');
const { getRandomArrayItems } = require('./arrayHelper');
const { filterAttributesForElement } = require('./attributes');
const { getUserNameFromProfile } = require('./auth');
const { Log } = require('./browserLogger');
const { isColorSettingValidClassName } = require('./classNames');
const { createOpenGraph, getOGImages } = require('./createOpenGraph');
const {
  AUTH0,
  BREAKPOINTS,
  CENTER_OF_USA,
  DAYS_OF_WEEK,
  DELIMITERS,
  GLOBAL_SUPPORTED_ATTRIBUTES,
  MAGNOLIA_ENDPOINT_WORKSPACE_MAP,
  STATUS_TYPES,
  SUPPORTED_ATTRIBUTES,
  US_STATES,
} = require('../constants');
const {
  SUPPORTED_CHARACTERS,
  cleanseInput,
  formatNumberAsCurrency,
  formatWithCommas,
} = require('./currency');
const {
  MONTHS,
  calculateDaysOffset,
  calculateMonthOffset,
  closestTwiceMonthlyDate,
  formatDate,
  formatTimeTo12h,
  normalizeTimestamp,
  relativeDateLabel,
  timestampToDate,
} = require('./date');
const {
  getStateCodeFromName,
  getStateData,
  getStateNameFromCode,
  setMapCoordinates,
} = require('./locationsHelper');

/* Magnolia Helpers */
const {
  GenerateMagnoliaPageJSON,
  addFingerprintToUrl,
  addParamsToUrl,
  addSmoothScrolling,
  addWorkspaceToItems,
  changeLanguage,
  checkIfIsImgixUrl,
  checkLogin,
  collectionTypeToPath,
  convertS3DamItems,
  convertToCmsAssetUrl,
  escapeUrl,
  findLastModifiedOnPage,
  flattenObject,
  generateAlbumSubtitle,
  generateAlbumSubtitleByMediaItem,
  getAPIBase,
  getCurrentLanguage,
  getFingerprint,
  getHashedIds,
  getLabelList,
  getLabelValue,
  getLabelValueV2,
  getLanguages,
  getLogoPathBasedOnCollectionType,
  getMagnoliaItem,
  getMgnlBase,
  getRouterBasename,
  getUrlStructureByData,
  getUrlStructureByPath,
  getWorkspace,
  isAuthenticated,
  isMagnoliaAuthor,
  isMagnoliaPublic,
  isOrganizationProfile,
  logout,
  mediaTypeFromUuid,
  mediaTypeToPath,
  mediaUrlFromType,
  normalizeContentList,
  rectifyMediaCollectionType,
  removeCurrentLanguage,
  replaceMagnoliaAssetsToImgix,
  sortDateBased,
  sortEpisodeBased,
  sortMedia,
  stringToSlug,
  uuidFromMediaType,
} = require('./magnolia');

const { paramsToJSON } = require('./paramsToJSON');
const { paramsToQuery } = require('./paramsToQuery');
const {
  CALCULATION_METHODS,
  calculateDistanceFromGeolocationCoordinates,
} = require('./position');
const {
  addQueryParamToUrl,
  combineQueryParamsAndUrl,
  getQueryParam,
  getQueryParams,
} = require('./queryParams');
const {
  GTM_TYPES,
  generateBrightEdgeAutoPilotScriptMarkup,
  generateGtmScriptMarkup,
  generateNewRelicBrowserMonitorScriptMarkup,
  generateOsanoConsentManagerScriptMarkup,
  implementAnchorTagAttributes,
  injectScript,
  isValidGtmId,
} = require('./scriptHelper');
const { setupJest } = require('./setupJest');
const {
  camelToSnake,
  createSlugFromString,
  getFileExtension,
  getLetterForNumber,
} = require('./strings');
const { encodeSVG } = require('./svg');
const { titleCase } = require('./titleCase');
const { toType } = require('./toType');
const { transformKeys } = require('./transformKeys');
const { truncate } = require('./truncate');
const {
  extractFragment,
  getSearchParamsFrom,
  implementUtmParams,
} = require('./utmParams');
const { convertValueToClassName } = require('./validators');

module.exports = {
  addFingerprintToUrl,
  addParamsToUrl,
  addQueryParamToUrl,
  addSmoothScrolling,
  addWorkspaceToItems,
  AUTH0,
  BREAKPOINTS,
  generateBrightEdgeAutoPilotScriptMarkup,
  calculateDaysOffset,
  calculateDistanceFromGeolocationCoordinates,
  calculateMonthOffset,
  CALCULATION_METHODS,
  callGtagConfig,
  callGtagEvent,
  callSegmentIdentify,
  callSegmentPage,
  callSegmentTrack,
  camelToSnake,
  CENTER_OF_USA,
  changeLanguage,
  checkIfIsImgixUrl,
  checkLogin,
  cleanseInput,
  closestTwiceMonthlyDate,
  collectionTypeToPath,
  combineQueryParamsAndUrl,
  convertS3DamItems,
  convertToCmsAssetUrl,
  convertValueToClassName,
  createOpenGraph,
  createSlugFromString,
  DAYS_OF_WEEK,
  DELIMITERS,
  encodeSVG,
  escapeUrl,
  extractFragment,
  filterAttributesForElement,
  findLastModifiedOnPage,
  flattenObject,
  formatDate,
  formatNumberAsCurrency,
  formatTimeTo12h,
  formatWithCommas,
  GenerateMagnoliaPageJSON,
  GTM_TYPES,
  generateAlbumSubtitle,
  generateAlbumSubtitleByMediaItem,
  generateGtmScriptMarkup,
  getAPIBase,
  getCurrentLanguage,
  getFileExtension,
  getFingerprint,
  getHashedIds,
  getLabelList,
  getLabelValue,
  getLabelValueV2,
  getLanguages,
  getLetterForNumber,
  getLogoPathBasedOnCollectionType,
  getMagnoliaItem,
  getMgnlBase,
  getOGImages,
  getQueryParam,
  getQueryParams,
  getRandomArrayItems,
  getRouterBasename,
  getSearchParamsFrom,
  getStateCodeFromName,
  getStateData,
  getStateNameFromCode,
  getUrlStructureByData,
  getUrlStructureByPath,
  getUserNameFromProfile,
  getWorkspace,
  GLOBAL_SUPPORTED_ATTRIBUTES,
  implementAnchorTagAttributes,
  implementUtmParams,
  injectScript,
  isAuthenticated,
  isColorSettingValidClassName,
  isMagnoliaAuthor,
  isMagnoliaPublic,
  isOrganizationProfile,
  isValidGtmId,
  Log,
  generateNewRelicBrowserMonitorScriptMarkup,
  logout,
  MAGNOLIA_ENDPOINT_WORKSPACE_MAP,
  mediaTypeFromUuid,
  mediaTypeToPath,
  mediaUrlFromType,
  MONTHS,
  normalizeContentList,
  normalizeTimestamp,
  generateOsanoConsentManagerScriptMarkup,
  paramsToJSON,
  paramsToQuery,
  rectifyMediaCollectionType,
  relativeDateLabel,
  removeCurrentLanguage,
  replaceMagnoliaAssetsToImgix,
  setMapCoordinates,
  setupJest,
  sortDateBased,
  sortEpisodeBased,
  sortMedia,
  STATUS_TYPES,
  stringToSlug,
  SUPPORTED_ATTRIBUTES,
  SUPPORTED_CHARACTERS,
  timestampToDate,
  titleCase,
  toType,
  transformKeys,
  truncate,
  US_STATES,
  uuidFromMediaType,
};
